<template>
  <div class="PageComponent"></div>
</template>

<script>
import "../../public/css/netjsongraph-theme.css";
import "../../public/css/netjsongraph.css";
import axios from "axios";
import { lighten } from "polished";
export default {
  name: "TrafficViewComponent",
  metaInfo: {
    title: "TrafficView",
    meta: [
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0",
      },
    ],
  },

  mounted() {
    this.loadExternalScript();
  },
  methods: {
    // 外部スクリプトが読み込まれた後、NetJSONGraphのインスタンスを作成
    loadExternalScript() {
      const scriptTag = document.createElement("script");
      scriptTag.type = "application/javascript";
      scriptTag.src = "/dist/netjsongraph.min.js";
      scriptTag.onload = async () => {
        //AP情報(Node)のレイアウト設定 node.ASNRegionalTierの値によって変化。
        const NodeStyle = {
          1: {
            opacity: 1,
            borderWidth: 1,
            borderColor: "#000",
            color: "#2ca9e1", //blue
          },
          2: {
            opacity: 1,
            borderWidth: 1,
            borderColor: "#000",
            color: "#b8d200", //green
          },
          3: {
            opacity: 1,
            borderWidth: 1,
            textColor: "#444",
            borderColor: "#000",
            color: "#ffd900", //yellow
          },
          4: {
            opacity: 1,
            borderWidth: 1,
            textColor: "#444",
            borderColor: "#000",
            color: "#ffd900",
          },
          5: {
            opacity: 1,
            borderWidth: 1,
            textColor: "#444",
            borderColor: "#000",
            color: "#ffd900",
          },
          6: {
            opacity: 1,
            borderWidth: 1,
            textColor: "#444",
            borderColor: "#000",
            color: "#fff200",
          },
          9: {
            opacity: 1,
            borderWidth: 1,
            textColor: "#444",
            borderColor: "#000",
            color: "#ff8400", //#orange
          },
        };
        //POI情報(link)のレイアウト設定 link.Relationship_A_Bの値によって変化。
        const LinkStyle = {
          1: {
            r: 3,
            opacity: 1,
            color: "#29B8DB", //aqua
          },
          2: {
            r: 2,
            color: "#0BE0A0", //mint
            opacity: 1,
          },
          3: {
            r: 1,
            color: "#778899", //lightslategray
            opacity: 1,
          },
          4: {
            r: 0.5,
            opacity: 0.5,
            curveness: 0.2,
            color: "#778899", //lightslategray
            type: "dashed",
          },
        };
        //各layerごとに出される結果を分岐させる。
        const queryParams = this.$route.query;
        const layer1Id = queryParams.layer1_id;
        const layer2Id = queryParams.layer2_id;
        const as1Id = queryParams.as1_id;
        const as2Id = queryParams.as2_id;
        showLoadingLayer();
        let response;
        //デプロイ用 https://jpisp-sim.com:3000
        //新規開発版 https://tk2-216-17629.vs.sakura.ne.jp:3000
        //ローカル用 http://localhost:3000
        if (layer1Id && layer2Id && as1Id && as2Id) {
          response = await axios.get(`https://jpisp-sim.com:3000/traffic-view?layer1_id=${layer1Id}&layer2_id=${layer2Id}`);
        } else {
          return;
        }

        let graphData = {
          links: response.data.links,
          nodes: response.data.nodes,
        };
        processNodesLinks(graphData, as1Id, as2Id);
        processNodesCoordinates(graphData);

        const graph = new window.NetJSONGraph(graphData, {
          //dealDataByWorker: "/simulator/js/netjsonWorker.js",

          nodeSize: (node) => {
            switch (node.ASNRegionalTier) {
              case 1:
                return Math.sqrt(4000);
              case 2:
                return Math.sqrt(2000);
              case 3:
                return Math.sqrt(500);
              case 9:
                return Math.sqrt(1500);
              default:
                return Math.sqrt(500);
            }
          },
          linkStyleProperty: (link) => {
            const baseStyle = LinkStyle[link.Relationship_A_B] || {};
            return Object.assign({}, baseStyle);
          },
          nodeStyleProperty: (node) => {
            return Object.assign(
              {
                opacity: 1,
                borderWidth: 1,
                borderColor: "#fff",
              },
              NodeStyle[node.ASNRegionalTier]
            );
          },
          graphConfig: {
            color: "#2cb4ad",
            invisible: false,
          },
          mapTileConfig: [
            {
              urlTemplate: "https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png",
              options: {
                minZoom: 0.25,
                maxZoom: 18,
              },
            },
          ],
          mapOptions: {
            center: [36, 139],
            zoom: 7,
          },
          maintainAspectRatio: true,
          prepareData: (data) => {
            data.nodes.map((node) => {
              node.label = node.name;
              node.properties = Object.assign(node.properties || {}, {
                location: node.location,
                APサービス種別: node.ap_service_func,
                アクセス網接続: node.ap_func_access_network,
                国内Tier: node.ASNRegionalTier,
                AS番号: node.asn,
                AS名: node.as_name,
                ASネットワーク種別: node.as_info_type,
                施設名称: node.facility_name,
                施設管理組織名: node.facility_manag_org,
                施設所在国: node.facility_country,
                施設郵便番号: node.facility_zip_code,
                施設都道府県: node.facility_state,
                施設市町村: node.facility_city,
                組織名: node.org_name,
                組織登録国: node.org_country,
                作成日時: node.create_date,
                住所1: node.add1,
                住所2: node.add2,
              });
            });
            data.nodes.map((node) => {
              // 特定の AP サービスタイプに対して、異なる記号を設定する:
              switch (node.ap_service_func) {
                case 3:
                  // 六角形
                  node.symbol = "path://M0,-10 L8.660254,-5 L8.660254,5 L0,10 L-8.660254,5 L-8.660254,-5 Z";
                  break;
                case 2:
                  // クラウドアイコン
                  node.symbol = "path://M-12,2 a6,6 0 0 1 6,-6 a9,9 0 0 1 14,3 a6,6 0 0 1 4,6 a6,6 0 0 1 -6,6 h-18 a6,6 0 0 1 -6,-6 a6,6 0 0 1 2,-3 z";
                  break;
                case 4:
                  // 円柱アイコン
                  node.symbol = "path://M-18,-8 a18,8 0 1,0 36,0 a18,8 0 1,0 -36,0 M-18,-8 v24 a18,8 0 1,0 36,0 v-24 M-18,16 a18,8 0 1,0 36,0 a18,8 0 1,0 -36,0";
                  break;
              }

              node.properties = Object.assign(node.properties || {}, {
                category: "tier" + node.ASNRegionalTier,
              });
            });
            data.links.map((link) => {
              link.properties = link.properties || {};
              if (link.properties.status) {
                link.category = link.properties.status;
              }
            });
            data.links.map((link) => {
              link.properties = Object.assign(link.properties || {}, {
                ポイントAB間POIのID: link.poi_id,
                POI名称: link.poi_name,
                回線容量Gbps: link.nw_band_width,
                平均使用率AからB: link.average_utilization_a_out,
                平均使用率BからA: link.average_utilization_a_in,
                最頻使用率AからB: link.peak_utilization_a_out,
                最頻使用率BからA: link.peak_utilization_a_in,
                回線運用状態: link.nw_operational_status,
                作成日時: link.create_date,
              });
            });
          },
          onLoad: function () {
            this.utils.hideLoading();
            createPathsInfo();
            SwitchLinkStyle(this);
            hideLoadingLayer();

            // 検索ボックスを作成
            let searchContainer = document.createElement("div"),
              searchInput = document.createElement("input"),
              searchBtn = document.createElement("button"),
              clearBtn = document.createElement("button"),
              searchSelect = document.createElement("select");
            searchInput.setAttribute("class", "njg-searchInput");
            searchBtn.setAttribute("class", "njg-searchBtn");
            clearBtn.setAttribute("class", "njg-searchBtn");
            searchBtn.innerHTML = "検索";
            clearBtn.innerHTML = "クリア";
            searchContainer.setAttribute("class", "njg-searchContainer");

            // ドロップダウンのオプションを追加
            const searchOptions = [
              { value: "name", label: "AP名で検索" },
              { value: "asn", label: "AS番号で検索" },
              { value: "ap_id", label: "AP番号で検索" },
            ];
            searchOptions.forEach((option) => {
              const opt = document.createElement("option");
              opt.value = option.value;
              opt.innerText = option.label;
              searchSelect.appendChild(opt);
            });
            searchSelect.setAttribute("class", "njg-searchSelect");

            // 検索ボックスに要素を追加
            searchContainer.appendChild(searchSelect);
            searchContainer.appendChild(searchInput);
            searchContainer.appendChild(searchBtn);
            searchContainer.appendChild(clearBtn);
            this.el.appendChild(searchContainer);

            // 検索ボタンのクリックイベント
            searchBtn.onclick = () => {
              const searchValue = searchInput.value.trim();
              const searchMode = searchSelect.value;
              const nodes = this.data.nodes;

              // 条件に応じたノードのフィルタリング
              const matchedNodes = nodes.filter((node) => {
                switch (searchMode) {
                  case "name":
                    return node.name && node.name.includes(searchValue);
                  case "asn":
                    return node.asn && node.asn == searchValue;
                  case "ap_id":
                    return node.id && node.id == searchValue;
                  default:
                    return false;
                }
              });

              if (matchedNodes.length > 0) {
                nodes.forEach((node) => {
                  // 分類属性が常に存在することを保証する
                  node.properties = Object.assign(node.properties || {}, {
                    category: "tier" + node.ASNRegionalTier,
                  });

                  if (!matchedNodes.includes(node)) {
                    // 検索結果に一致しないノード
                    node.customStyle = {
                      ...NodeStyle[node.ASNRegionalTier],
                      color: lighten(-0.15, NodeStyle[node.ASNRegionalTier].color),
                      size: nodeSize(node),
                    };
                  } else {
                    // 検索結果に一致するノード
                    node.customStyle = {
                      ...NodeStyle[node.ASNRegionalTier],
                      opacity: NodeStyle[node.ASNRegionalTier].opacity,
                      size: nodeSize(node),
                    };
                  }
                });

                // グラフを再描画
                this.echarts.setOption({
                  series: [
                    {
                      data: nodes.map((node) => ({
                        ...node,
                        category: node.properties.category,
                        itemStyle: {
                          color: node.customStyle.color,
                          borderColor: node.customStyle.borderColor,
                          opacity: node.customStyle.opacity,
                        },
                        symbolSize: node.customStyle.size,
                      })),
                    },
                  ],
                });
              }
            };

            // クリアボタンのクリックイベント
            clearBtn.onclick = () => {
              const nodes = this.data.nodes;

              // すべてのノードスタイルをリセット
              nodes.forEach((node) => {
                // 分類属性の保持を確認する
                node.properties = Object.assign(node.properties || {}, {
                  category: "tier" + node.ASNRegionalTier,
                });

                node.customStyle = {
                  ...NodeStyle[node.ASNRegionalTier],
                  size: nodeSize(node),
                };
              });
              this.echarts.setOption({
                series: [
                  {
                    data: nodes.map((node) => ({
                      ...node,
                      category: node.properties.category,
                      itemStyle: {
                        color: node.customStyle.color,
                        borderColor: node.customStyle.borderColor,
                        opacity: node.customStyle.opacity,
                      },
                      symbolSize: node.customStyle.size,
                    })),
                  },
                ],
              });
              this.utils.hideLoading();
              // 検索フィールドと選択状態をクリア
              searchInput.value = "";
              searchSelect.value = "name";
              console.log("検索結果がクリアされました");
            };
            function nodeSize(node) {
              switch (node.ASNRegionalTier) {
                case 1:
                  return Math.sqrt(4000);
                case 2:
                  return Math.sqrt(2000);
                case 3:
                  return Math.sqrt(500);
                case 9:
                  return Math.sqrt(1500);
                default:
                  return Math.sqrt(500);
              }
            }
          },
        });
        graph.render();
        window.myGraph = graph;
        
        // Process auto layout only when the diagram is truly ready.
        graph.event.on('onLoad', () => {
          const enabled = window.getAutoLayoutEnabled();
          window.setAutoLayoutEnabled(enabled);
          window.syncAutoLayoutIcon(enabled);
          if (enabled) {
            window.runAutoLayout();
          }
        });

        function processNodesLinks(graphData, as1Id, as2Id) {
          const startApIds = graphData.nodes.filter((ap) => String(ap.asn) == as1Id).map((ap) => String(ap.id));
          const endApIds = new Set(graphData.nodes.filter((ap) => String(ap.asn) == as2Id).map((ap) => String(ap.id)));

          const graph = buildGraphWithData(graphData.links);
          const pathsInfo = floodingPoiPath(graph, startApIds, endApIds);
          pathsInfo.startApIds = startApIds;
          pathsInfo.endApIds = Array.from(endApIds);

          const allPaths = [...pathsInfo.shortestPaths.map((p) => p.path), ...pathsInfo.nextLevelPaths.map((p) => p.path)];

          let allApObjectsByPath = allPaths.flatMap((path) => {
            const apMap = new Map();
            for (const ap of graphData.nodes) {
              apMap.set(ap.id, ap);
            }
            return path.map((id) => apMap.get(id)).filter(Boolean);
          });
          const uniqueApObjects = Array.from(new Map(allApObjectsByPath.map((ap) => [ap.id, ap])).values());

          [...pathsInfo.startApIds, ...pathsInfo.endApIds].forEach((apId) => {
            if (!uniqueApObjects.find((item) => apId == item.id)) {
              uniqueApObjects.push(graphData.nodes.find((item) => apId == item.id));
            }
          });

          const mergedPoiPath = [...pathsInfo.shortestPaths, ...pathsInfo.nextLevelPaths].flatMap((item) => item.poiPath);
          const formattedResults = uniqueApObjects.map((row) => ({
            id: row.id,
            name: row.name,
            ASNRegionalTier: row.ASNRegionalTier,
            location: {
              lat: row.lat,
              lng: row.lng,
            },
            ap_service_func: row.ap_service_func,
            ap_func_access_network: row.ap_func_access_network,
            asn: row.asn,
            as_name: row.as_name,
            as_info_type: row.as_info_type,
            facility_name: row.facility_name,
            facility_manag_org: row.facility_manag_org,
            facility_country: row.facility_country,
            facility_zip_code: row.facility_zip_code,
            facility_state: row.facility_state,
            facility_city: row.facility_city,
            org_name: row.org_name,
            org_country: row.org_country,
            create_date: row.create_date,
          }));

          graphData.nodes = formattedResults;
          graphData.links = mergedPoiPath;
          graphData.pathsInfo = pathsInfo;
        }

        function processNodesCoordinates(graphData) {
          let startApIds = graphData.pathsInfo.startApIds;
          let endApIds = graphData.pathsInfo.endApIds;
          let shortestPaths = graphData.pathsInfo.shortestPaths;
          let nextLevelPaths = graphData.pathsInfo.nextLevelPaths;
          let allPathsNode = {};

          const startSet = new Set(startApIds);
          const endSet = new Set(endApIds);

          const startIndexMap = new Map(startApIds.map((id, i) => [id, i]));
          const endIndexMap = new Map(endApIds.map((id, i) => [id, i]));

          const nodeY = 1000;
          const centerX = 1200;
          let distanceY = 120;
          let distanceX = 80;

          function normalizePath(pathObj) {
            return {
              ...pathObj,
              pathSet: new Set(pathObj.path),
              indexMap: new Map(pathObj.path.map((id, i) => [id, i])),
            };
          }

          shortestPaths = shortestPaths.map(normalizePath);
          nextLevelPaths = nextLevelPaths.map(normalizePath);

          if (nextLevelPaths[0]?.path?.length) {
            distanceY = nodeY / (nextLevelPaths[0].path.length - 1);
          } else if (shortestPaths[0]?.path?.length) {
            distanceY = nodeY / (shortestPaths[0].path.length - 1);
          }

          graphData.nodes.forEach((node) => {
            if (startSet.has(node.id)) {
              const dirI = startIndexMap.get(node.id);
              const dir = dirI % 2 === 0 ? -1 : 1;
              const step = Math.ceil(dirI / 2);

              node.x = centerX + step * distanceX * dir;
              node.y = nodeY;
              return;
            }

            if (endSet.has(node.id)) {
              const dirI = endIndexMap.get(node.id);
              const dir = dirI % 2 === 0 ? -1 : 1;
              const step = Math.ceil(dirI / 2);

              node.x = centerX + step * distanceX * dir;
              node.y = 100;
              return;
            }

            let maxLevel = -1;

            shortestPaths.forEach((p) => {
              if (p.pathSet.has(node.id)) {
                const idx = p.indexMap.get(node.id);
                if (idx > maxLevel) maxLevel = idx;
              }
            });

            nextLevelPaths.forEach((p) => {
              if (p.pathSet.has(node.id)) {
                const idx = p.indexMap.get(node.id);
                if (idx > maxLevel) maxLevel = idx;
              }
            });

            if (maxLevel !== -1) {
              allPathsNode[node.id] = maxLevel;

              let sameLevelCount = Object.values(allPathsNode).filter((v) => v === maxLevel).length - 1;

              const dir = sameLevelCount % 2 === 0 ? -1 : 1;
              const step = Math.ceil(sameLevelCount / 2);

              node.x = centerX + step * distanceX * dir;
              node.y = nodeY - distanceY * maxLevel;
            }
          });
        }

        function buildGraphWithData(poiList) {
          const graph = new Map();

          for (const poi of poiList) {
            const a = poi.source;
            const b = poi.target;

            if (!graph.has(a)) graph.set(a, []);
            if (!graph.has(b)) graph.set(b, []);

            graph.get(a).push({ next: b, poi });
            graph.get(b).push({ next: a, poi });
          }
          return graph;
        }

        function floodingPoiPath(graph, startApIds, endApIds) {
          const shortestPaths = [];
          const nextLevelPaths = [];

          if (startApIds.length === 0 || endApIds.size === 0) {
            return { shortestPaths, nextLevelPaths };
          }

          const nodeInfo = new Map();

          const currentLevel = new Map();
          for (const s of startApIds) {
            currentLevel.set(s, [{ from: null, poi: null }]);
            nodeInfo.set(s, { depth: 0, predecessors: [] });
          }

          let depth = 0;
          let shortestDepth = null;
          const maxDepth = 10000;

          while (currentLevel.size > 0 && depth < maxDepth) {
            const nextLevel = new Map();

            for (const [node, paths] of currentLevel) {
              if (endApIds.has(node)) {
                if (shortestDepth === null) {
                  shortestDepth = depth;
                }

                for (const pathInfo of paths) {
                  const reconstructed = reconstructPath(node, pathInfo, nodeInfo);
                  if (depth === shortestDepth) {
                    shortestPaths.push(reconstructed);
                  } else if (depth === shortestDepth + 1) {
                    nextLevelPaths.push(reconstructed);
                  }
                }
                continue;
              }

              if (shortestDepth !== null && depth >= shortestDepth + 1) {
                continue;
              }

              const neighbors = graph.get(node);
              if (!neighbors) continue;

              for (const edge of neighbors) {
                const nxt = edge.next;

                const info = nodeInfo.get(nxt);
                if (info && info.depth < depth) continue;

                if (!nextLevel.has(nxt)) {
                  nextLevel.set(nxt, []);
                }

                for (const pathInfo of paths) {
                  nextLevel.get(nxt).push({
                    from: node,
                    poi: edge.poi,
                    previousPath: pathInfo,
                  });
                }

                if (!nodeInfo.has(nxt)) {
                  nodeInfo.set(nxt, { depth: depth + 1, predecessors: [] });
                }
              }
            }

            currentLevel.clear();
            for (const [node, paths] of nextLevel) {
              currentLevel.set(node, paths);
            }

            depth++;
          }

          return { shortestPaths, nextLevelPaths };
        }

        function reconstructPath(endNode, pathInfo) {
          const path = [];
          const poiPath = [];

          let current = endNode;
          let info = pathInfo;

          while (info && info.from !== null) {
            path.unshift(current);
            if (info.poi !== null) {
              poiPath.unshift(info.poi);
            }
            current = info.from;
            info = info.previousPath;
          }

          path.unshift(current);

          return { path, poiPath };
        }

        function createPathsInfo() {
          let pathsInfo = window.pathsInfo ?? graphData.pathsInfo;
          let pathsInfoHtml = "";
          let shortestPaths = pathsInfo?.shortestPaths ?? [];
          let nextLevelPaths = pathsInfo?.nextLevelPaths ?? [];
          
          pathsInfoHtml += "<p><b>最短経路の一覧</b></br>";
          shortestPaths.forEach((item) => {
            pathsInfoHtml += `<span>${item.path.join(" → ")}</span>`;
          });
          pathsInfoHtml += "</p>";

          pathsInfoHtml += "<p><b>最短経路+１のホップの一覧</b></br>";
          nextLevelPaths.forEach((item) => {
            pathsInfoHtml += `<span>${item.path.join(" → ")}</span>`;
          });
          pathsInfoHtml += "</p>";

          const containerDiv = `
          <div class="njg-pathsInfo njg-container" id="njg-pathsInfo" style="display: block">
            <div class="njg-inner" id="metadata-innerDiv">
            ${pathsInfoHtml}
            </div>
            <a class="njg-close" id="pathsInfo-close"></a>
          </div>
          `;

          const container = document.createElement("div");
          container.innerHTML = containerDiv;

          document.body.appendChild(container.firstElementChild);

          const i = document.getElementById("pathsInfo-close");
          i.onclick = () => {
            document.getElementById("njg-pathsInfo").style.visibility = "hidden";
          };
        }

        function showLoadingLayer() {
          if (document.getElementById("loading-layer")) return;

          const loadingLayer = document.createElement("div");
          loadingLayer.id = "loading-layer";

          Object.assign(loadingLayer.style, {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "#fff",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "28px",
            color: "#333",
            fontWeight: "bold",
          });

          loadingLayer.textContent = "読み込み中…";

          document.body.appendChild(loadingLayer);
        }

        function SwitchLinkStyle(_this) {
          const switchLinkStyleButton = document.createElement("div"); // ボタン用のコンテナ
          switchLinkStyleButton.style.position = "fixed";
          switchLinkStyleButton.style.bottom = "10px";
          switchLinkStyleButton.style.left = "10px"; // 固定位置
          const iconButton = document.createElement("button"); // ボタン要素に変更
          iconButton.innerHTML = "！"; // ボタンの中身
          iconButton.setAttribute("class", "burger-button"); // クラスを適用してレイアウトを統一
          const tooltip = document.createElement("div"); // ツールチップ
          tooltip.textContent = "逼迫状況表示";
          tooltip.className = "tooltip";
          switchLinkStyleButton.appendChild(iconButton);
          switchLinkStyleButton.appendChild(tooltip);
          iconButton.addEventListener("mouseenter", () => {
            tooltip.classList.add("visible");
          });
          iconButton.addEventListener("mouseleave", () => {
            tooltip.classList.remove("visible");
          });
          
          let isDefaultStyle = true;
          iconButton.onclick = () => {
            isDefaultStyle = !isDefaultStyle; // スタイルをトグル
            if (isDefaultStyle) {
              // 元のスタイルに戻す
              _this.config.linkStyleProperty = link => {return LinkStyle[link.Relationship_A_B] || {};};
            } else {
              _this.config.linkStyleProperty = link => {
                const baseStyle = LinkStyle[link.Relationship_A_B] || {};
                let calculatedWidth;
                let calculatedColor;
                // 線の太さ変更
                if (link.nw_band_width <= 10) {
                  calculatedWidth = 1;
                } else if (link.nw_band_width >= 10 && link.nw_band_width <= 99) {
                  calculatedWidth = 5;
                } else if (link.nw_band_width >= 100) {
                  calculatedWidth = 10;
                }
                // 線の色変更
                const utilizationPercentage = ((link.average_utilization_a_in + link.average_utilization_a_out) / 100) * link.nw_band_width;
                const percentageOfBandwidth = (utilizationPercentage / link.nw_band_width) * 100;
                if (percentageOfBandwidth === 0) {
                  calculatedColor = '#BFBFBF'; // default
                } else if (percentageOfBandwidth > 0 && percentageOfBandwidth <= 10) {
                  calculatedColor = '#BFBFBF'; // gray(pale)
                } else if (percentageOfBandwidth > 10 && percentageOfBandwidth <= 40) {
                  calculatedColor = '#B3D5FF'; // blue(pale)
                } else if (percentageOfBandwidth > 40 && percentageOfBandwidth <= 70) {
                  calculatedColor = '#FFABB0'; // pink(pale)
                } else if (percentageOfBandwidth > 70 && percentageOfBandwidth < 100) {
                  calculatedColor = '#FF6E76'; // carmine(pale)
                } else if (percentageOfBandwidth >= 100) {
                  calculatedColor = '#EB1A28'; // red(pale)
                } else {
                  calculatedColor = '#BFBFBF'; // default
                }
                return Object.assign({}, baseStyle, {
                  width: calculatedWidth,
                  color: calculatedColor
                });
              };
            }
            // グラフのリンク情報のみ再描画
            _this.echarts.setOption({series: [{type: 'graph',links: _this.data.links.map(link => ({...link,lineStyle: _this.config.linkStyleProperty(link)}))}]}, false);
          };
          document.body.appendChild(switchLinkStyleButton);
        }

        function hideLoadingLayer() {
          const loadingLayer = document.getElementById("loading-layer");
          if (loadingLayer) {
            loadingLayer.remove();
          }
        }
      };
      document.body.appendChild(scriptTag);
    },
  },
};
</script>
<style>
.njg-pathsInfo {
  position: absolute;
  left: 10px;
  top: 200px;
  width: 380px;
  word-break: break-all;
  z-index: 999;
  user-select: text;
  min-height: 300px;
  max-height: 530px;
  overflow-y: auto;
  line-height: 1.3;
}
.njg-pathsInfo .njg-inner {
  margin-top: 1em;
}
.njg-pathsInfo p span {
  display: block;
  margin-bottom: 12px;
}

.njg-pathsInfo p b {
  display: inline-block;
  margin-bottom: 6px;
}

.njg-pathsInfo p {
  margin-bottom: 0px;
  margin-top: 0px;
}
</style>
